module.exports = __webpack_public_path__ + "img/vs.4f0627ad.png";